import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { PromoB2BWidget } from 'widgets/promoB2B/ui/PromoB2BWidget';

export const PromoB2BPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Промо B2B'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <PromoB2BWidget />;
};
